import { FC, useCallback } from 'react'

import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import Button from 'components/features/pfm/Button/Button'
import { startRedemptionFlowActionCreator } from 'actions/bountyActions'
import { REDEMPTION_PAGE } from 'constants/pages'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

import styles from 'components/features/rewards/rewardPageSummary/RedeemButton/RedeemButton.styl'

type RedeemButtonProps = {
}

export const RedeemButton: FC<RedeemButtonProps> = () => {
  const dispatch = useStoreDispatch()
  const openBuyCryptoPane = useCallback(() => {
    dispatch(startRedemptionFlowActionCreator)
  }, [dispatch])

  return (
    <NavigationLink to={ REDEMPTION_PAGE } className={ styles.link }>
      <Button fullWidth style='textOnly' size='tiny' onClick={ openBuyCryptoPane }>
        Redeem
      </Button>
    </NavigationLink>
  )
}
